export const FETCH_QUESTIONNAIRE_REQUEST = "FETCH_QUESTIONNAIRE_REQUEST";
export const FETCH_QUESTIONNAIRE_SUCCESS = "FETCH_QUESTIONNAIRE_SUCCESS";
export const FETCH_QUESTIONNAIRE_FAILURE = "FETCH_QUESTIONNAIRE_FAILURE";

export const SUBMIT_QUESTIONNAIRE_REQUEST = "SUBMIT_QUESTIONNAIRE_REQUEST";
export const SUBMIT_QUESTIONNAIRE_SUCCESS = "SUBMIT_QUESTIONNAIRE_SUCCESS";
export const SUBMIT_QUESTIONNAIRE_FAILURE = "SUBMIT_QUESTIONNAIRE_FAILURE";

export const FETCH_ANSWERS_REQUEST = "FETCH_ANSWERS_REQUEST";
export const FETCH_ANSWERS_SUCCESS = "FETCH_ANSWERS_SUCCESS";
export const FETCH_ANSWERS_FAILURE = "FETCH_ANSWERS_FAILURE";
